export const formatQuestionOptions = (question) => {
  if (!question) return null;
  if (Array.isArray(question.options) && question.options.length > 0) {
    return question.options
      .map((option, idx) => {
        const label = String.fromCharCode(65 + idx);
        const value =
          typeof option === 'string'
            ? option
            : option?.text || option?.label || option?.value;
        return value ? `${label}) ${value}` : null;
      })
      .filter(Boolean)
      .join('\n');
  }

  const optionFields = ['option_A', 'option_B', 'option_C', 'option_D', 'option_E'];
  const optionValues = optionFields
    .map((field, idx) => {
      const value = question[field];
      return value ? `${String.fromCharCode(65 + idx)}) ${value}` : null;
    })
    .filter(Boolean);

  return optionValues.length > 0 ? optionValues.join('\n') : null;
};

export const formatDiagramContext = (question) => {
  if (!question) return null;
  const diagram =
    question.diagram ||
    question.diagram_data ||
    question.diagram_url ||
    question.diagram_image ||
    question.image;
  if (!diagram) return null;
  if (typeof diagram === 'string') return diagram;
  if (diagram?.code) return diagram.code;
  return JSON.stringify(diagram);
};

export const buildExplainPrompt = (question, { questionLabelPrefix = 'Question' } = {}) => {
  const questionLabel = question?.question_number
    ? `${questionLabelPrefix} ${question.question_number}`
    : 'this question';
  const questionText =
    question?.question_text || question?.question || 'Question text not available.';
  const diagramText = formatDiagramContext(question);
  const optionsText = formatQuestionOptions(question);
  const messageParts = [
    `Explain the concept behind ${questionLabel} in detail. Include key ideas and a step-by-step approach.`,
    `Question: ${questionText}`
  ];

  if (diagramText) {
    messageParts.push(`Diagram: ${diagramText}`);
  }

  if (optionsText) {
    messageParts.push(`Options:\n${optionsText}`);
  }

  return messageParts.join('\n');
};